export enum UsIsfCbpStatus {
  SUBMITTED = 'SUBMITTED',
  FILED = 'FILED',
  REJECTED = 'REJECTED',
  DELETED = 'DELETED',
}
